import { Suspense, lazy, useEffect, useRef, useState } from "react";

const WishlinkLottie = lazy(() =>
  import(/* webpackChunkName: "WishlinkLottie" */ "../WishlinkLottie")
);

const WishlinkLottieLazyLoad = ({ ...props }) => {
  const [isIntersecting, setIsIntersecting] = useState(false);
  // CAT-407 QA — this element, not whichever `#lottie` the document happens to
  // hold first. Two of these can be mounted at once (the setup journey overlay
  // sits on top of Home), and observing the wrong one leaves the animation on
  // top waiting for a visibility change that belongs to the screen underneath.
  const containerRef = useRef(null);

  const handleIntersection = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        setIsIntersecting(true);
      }
    });
  };

  useEffect(() => {
    const observer = new IntersectionObserver(handleIntersection, {
      rootMargin: "0px",
      threshold: 0.1,
    });

    if (containerRef.current) observer.observe(containerRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div id="lottie" ref={containerRef}>
      {isIntersecting && (
        <Suspense fallback={<></>}>
          <WishlinkLottie {...props} />
        </Suspense>
      )}
    </div>
  );
};

export default WishlinkLottieLazyLoad;
